module.exports = __webpack_public_path__ + "cu.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/cu.svg
// module id = 503
// module chunks = 0